import React, { useState, useEffect, FC } from 'react'
import { Button, ButtonGroup, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import CONSTANTS from '../../../../utils/constants'
import { useNavigate } from 'react-router-dom'
import { useCustomBackRouteNavigator } from '../../../../shared/hooks/use-route-navigator'
import SearchIcon from '@mui/icons-material/Search'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'

import { Download } from '@mui/icons-material'
import TextField from '@mui/material/TextField'
import { getDownloadReportFile, getReportsList } from '../../../../services/bff-service'
import { applyThrottle } from '../../../../utils/common-utils'
import { setSnackBar } from '../../../../stores/ui/ui-action'

interface UserListFiltersProps {
    defaultSearchText?: string
    onSearch: (searchText: string) => void
}

export const UserListFilters: FC<UserListFiltersProps> = ({ defaultSearchText, onSearch }) => {
    const styles = useStyles()
    const navigate = useNavigate()
    const {
        searchParams: { tab: filterType = 'active' }
    } = useCustomBackRouteNavigator('/svber/admin-panel/users')

    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState(defaultSearchText)
    const [reports, setReports] = useState([])

    useEffect(() => {
        getReportsList()
            .then((reports) => {
                setReports(reports)
            })
            .catch((err) => {
                console.error('Failed to fetch the reports list.')
            })
    }, [])

    const handleActiveClick = () => {
        navigate('?tab=active')
    }

    const handleInActiveClick = () => {
        navigate('?tab=inactive')
    }

    const handleChange = ({ target: { value } }) => {
        setSearchText(value)
        onSearch(value)
    }

    const REPORT_NAMES = {
        active: 'Lendx Active User List Report',
        inactive: 'Lendx In-active User List Report'
    }

    const handleDownload = async () => {
        try {
            const reportId = reports.find(({ report_name }) => report_name === REPORT_NAMES[filterType])?.report_id
            if (!reportId) {
                console.error(`The ${REPORT_NAMES[filterType]} id is not found.`)
                return
            }
            const { presignedURL } = await getDownloadReportFile(reportId)
            if (presignedURL) {
                let link = document.createElement('a')
                link.href = presignedURL
                link.click()
            }
        } catch (err) {
            dispatch(
                setSnackBar({
                    show: true,
                    message: 'Error',
                    description: err?.response?.data?.error?.message ?? err.message,
                    messageType: 'error'
                })
            )
        }
    }

    return (
        <>
            <Box className={styles.container}>
                <Box>
                    <Typography className={styles.header}>User List</Typography>
                </Box>
                <Box>
                    <ButtonGroup variant="outlined" className={styles.buttonGroup}>
                        <Button
                            className={styles.customButton}
                            variant={filterType === CONSTANTS.USER_LIST_FILTERS.ACTIVE ? 'contained' : 'outlined'}
                            color="primary"
                            onClick={handleActiveClick}
                        >
                            Active
                        </Button>
                        <Button
                            className={styles.customButton}
                            variant={filterType === CONSTANTS.USER_LIST_FILTERS.IN_ACTIVE ? 'contained' : 'outlined'}
                            color="primary"
                            onClick={handleInActiveClick}
                        >
                            Inactive
                        </Button>
                    </ButtonGroup>
                </Box>
                <Box className={styles.searchWrapper}>
                    <TextField
                        id="filled-search"
                        value={searchText}
                        onChange={handleChange}
                        fullWidth
                        className={styles.searchInput}
                        type="standard"
                        variant="outlined"
                        placeholder="Search..."
                        inputProps={{ 'data-testid': 'seachTextFeild' }}
                        InputProps={{
                            startAdornment: <SearchIcon />
                        }}
                        sx={{
                            input: {
                                '&::placeholder': {
                                    opacity: 1
                                }
                            }
                        }}
                    />
                    <Button
                        variant="outlined"
                        className={styles.customButton}
                        size="medium"
                        color="primary"
                        startIcon={<Download />}
                        data-testid="download"
                        onClick={applyThrottle(handleDownload, 1000)}
                    >
                        Download
                    </Button>
                </Box>
            </Box>
        </>
    )
}
